var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHigh(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 33,
    viewBox: "0 0 50 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.8862 39.2545C18.3992 39.0487 9.03534 38.6092 7.37314 38.4993C5.30738 38.3634 3.51732 34.2379 3.40144 29.6269C3.18568 20.9803 3.01786 12.2377 7.39312 8.33796C12.082 4.15649 16.5192 3.61308 24.4466 3.68101C31.1774 3.73695 38.1917 4.47015 42.4152 9.59061C45.9234 13.842 45.6856 23.2079 45.1862 28.4102C44.5888 34.6275 43.3801 39.0027 41.1825 39.1686C38.9849 39.3324 32.6737 39.5022 24.8862 39.2545Z",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.4463 3.75901C28.4463 3.75901 29.8987 2.76009 30.1145 2.09681C30.3302 1.43353 30.2284 1 30.2284 1",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8184 3.64669C29.8184 3.64669 30.2998 3.04135 31.2188 2.46198C31.6943 2.1623 32.2677 2.06641 32.2677 2.06641",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1191 13.1797L49.0005 13.8649",
    stroke: "black",
    strokeWidth: 0.998918,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.5752 11.1797L23.8531 13.1775",
    stroke: "black",
    strokeWidth: 0.998918,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.2709 13.8398L47.7655 22.4345L29.0078 21.5055",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.389 20.9771L1 19.8363L1.57538 11.1797",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8476 16.8759C25.0864 16.732 23.8218 16.6801 22.7989 16.9877C21.9837 17.2315 21.4883 17.701 21.4883 17.701C22.703 22.248 24.6988 23.2649 24.6988 23.2649C24.6988 23.2649 28.1191 20.9794 27.8993 18.1405",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2646 17.0813C33.2646 17.0813 37.3602 13.685 40.357 17.4809",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92779 16.0669C8.92779 16.0669 12.674 12.2887 16.0254 15.7755",
    stroke: "black",
    strokeWidth: 0.599351,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHigh);
export default __webpack_public_path__ + "static/media/high.19fc04da2782775bf8226effadb28a94.svg";
export { ForwardRef as ReactComponent };